import React, { useState } from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Exercises = () => {
  const exercises = [
    {
      question: "1. What does HTML stand for?",
      type: "mcq",
      options: [
        "Hyper Text Markup Language",
        "Home Tool Markup Language",
        "Hyperlinks and Text Markup Language",
        "Hyperlinking Text Mark Language",
      ],
      answer: "Hyper Text Markup Language",
    },
    {
      question: "2. Which tag is used to create a hyperlink?",
      type: "mcq",
      options: ["<link>", "<a>", "<href>", "<hyperlink>"],
      answer: "<a>",
    },
    {
      question: "3. Select all HTML semantic elements.",
      type: "checkbox",
      options: ["<header>", "<footer>", "<div>", "<section>", "<span>"],
      answer: ["<header>", "<footer>", "<section>"],
    },
    {
      question: "4. Write the correct HTML to display 'Hello World' in a heading.",
      type: "code",
      answer: "<h1>Hello World</h1>",
    },
    {
      question: "5. Input field for email should use which type?",
      type: "text",
      answer: "email",
    },
    {
      question: "6. Correct HTML for adding an image with src 'image.png'.",
      type: "code",
      answer: '<img src="image.png" alt="Description">',
    },
    {
      question: "7. What is the correct HTML element for inserting a line break?",
      type: "mcq",
      options: ["<break>", "<br>", "<lb>", "<line>"],
      answer: "<br>",
    },
    {
      question: "8. HTML element used for unordered list?",
      type: "mcq",
      options: ["<ul>", "<ol>", "<li>", "<list>"],
      answer: "<ul>",
    },
    {
      question: "9. Select the correct self-closing tags.",
      type: "checkbox",
      options: ["<img>", "<input>", "<div>", "<hr>", "<p>"],
      answer: ["<img>", "<input>", "<hr>"],
    },
    {
      question: "10. Write HTML code to create a table with 2 rows and 2 columns.",
      type: "code",
      answer:
        "<table>\n  <tr>\n    <td>Row1 Col1</td>\n    <td>Row1 Col2</td>\n  </tr>\n  <tr>\n    <td>Row2 Col1</td>\n    <td>Row2 Col2</td>\n  </tr>\n</table>",
    },
  ];

  const [userAnswers, setUserAnswers] = useState(
    exercises.map((ex) => (ex.type === "checkbox" ? [] : ""))
  );
  const [feedbacks, setFeedbacks] = useState(Array(exercises.length).fill(""));

  const handleAnswerChange = (index, value, option = null) => {
    const newAnswers = [...userAnswers];
    const newFeedbacks = [...feedbacks];

    if (exercises[index].type === "checkbox") {
      const current = newAnswers[index];
      if (current.includes(option)) {
        newAnswers[index] = current.filter((o) => o !== option);
      } else {
        newAnswers[index] = [...current, option];
      }
      newFeedbacks[index] =
        JSON.stringify(newAnswers[index].sort()) ===
        JSON.stringify(exercises[index].answer.sort())
          ? "Correct"
          : "Wrong";
    } else if (exercises[index].type === "mcq" || exercises[index].type === "text") {
      newAnswers[index] = value;
      newFeedbacks[index] =
        value.trim() === exercises[index].answer ? "Correct" : "Wrong";
    } else if (exercises[index].type === "code") {
      newAnswers[index] = value;
      // Normalize whitespace for comparison
      const normalize = (str) => str.replace(/\s+/g, " ").trim();
      newFeedbacks[index] =
        normalize(value) === normalize(exercises[index].answer) ? "Correct" : "Wrong";
    }

    setUserAnswers(newAnswers);
    setFeedbacks(newFeedbacks);
  };

  return (
    <div className="exercise-container">
      <h1>HTML Exercises</h1>
      {exercises.map((exercise, index) => (
        <div key={index} className="exercise-item">
          <p className="question">{exercise.question}</p>

          {exercise.type === "mcq" &&
            exercise.options.map((opt, i) => (
              <div key={i}>
                <label>
                  <input
                    type="radio"
                    name={`mcq-${index}`}
                    value={opt}
                    checked={userAnswers[index] === opt}
                    onChange={(e) => handleAnswerChange(index, e.target.value)}
                  />
                  {opt}
                </label>
              </div>
            ))}

          {exercise.type === "checkbox" &&
            exercise.options.map((opt, i) => (
              <div key={i}>
                <label>
                  <input
                    type="checkbox"
                    value={opt}
                    checked={userAnswers[index].includes(opt)}
                    onChange={() => handleAnswerChange(index, null, opt)}
                  />
                  {opt}
                </label>
              </div>
            ))}

          {exercise.type === "text" && (
            <input
              type="text"
              value={userAnswers[index]}
              onChange={(e) => handleAnswerChange(index, e.target.value)}
            />
          )}

          {exercise.type === "code" && (
            <textarea
              className="code-input"
              value={userAnswers[index]}
              onChange={(e) => handleAnswerChange(index, e.target.value)}
              placeholder="Type your code here..."
              rows={6}
              cols={50}
            />
          )}

          {feedbacks[index] && (
            <p className={`feedback ${feedbacks[index] === "Correct" ? "correct" : "wrong"}`}>
              {feedbacks[index]}
            </p>
          )}

          <hr className="divider" />
        </div>
      ))}
    </div>
  );
};

export default HTML_Exercises;
